import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { get, firestore, add } from "firebase_config";
import { capitalizeFirstLetter } from "helpers";
import { post } from "services";

function AdminZoneComponent({ currentUser }) {
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const postCategoryKeys = [
    "current_feeling",
    "happy",
    "sad",
    "surprise",
    "fear",
    "angry",
  ];

  const mergePosts = async () => {
    setLoading(true);
    const result = await get("activities");
    await result.map(async (activity, idx) => {
      const data = Object.assign({
        active: true,
        type: "activity",
        stories: [
          {
            text: capitalizeFirstLetter(activity.description),
          },
        ],
        userId: activity.userId,
        followers: [],
        followersCount: 0,
        category: {
          key: "other",
          title: activity.activity,
        },
        tradePrice: 0,
        anonymous: activity.anonymous,
        createdAt: activity.createdAt,
        updatedAt: activity.updatedAt,
      });
      await firestore.collection("posts").add(data);
    });
    setLoading(false);
  };

  const updateCategories = async () => {
    setLoading(true);
    const result = await get("posts");
    await result.map(async (post, idx) => {
      if (!post.resharePostId) {
        if (!postCategoryKeys.includes(post.category.key)) {
          await firestore
            .collection("posts")
            .doc(post.id)
            .update({
              category: {
                key: "other",
                title: post.category.title.toLowerCase(),
              },
            });
        }
      }
      /* Converting all categories to lowerCase */
      await firestore
        .collection("posts")
        .doc(post.id)
        .update({
          category: {
            key: post.category ? post.category.key : "other",
            title: post.category ? post.category.title.toLowerCase() : "other",
          },
        });
    });
    setLoading(false);
  };

  const updateRelationshipStatus = async () => {
    setLoading(true);
    const result = await get("userRelationships");
    await result.map(async (rln, idx) => {
      let status;
      if (!rln.status && rln.status !== null) {
        status = "pending";
      } else if (rln.status && rln.status === 1) {
        status = "followed";
      } else if (rln.status && rln.status === 2) {
        status = "declined";
      } else if (rln.status && rln.status === 3) {
        status = "blocked";
      }
      if (status && rln.status !== null) {
        await firestore
          .collection("userRelationships")
          .doc(rln.id)
          .update({ status });
      }
    });
    setLoading(false);
  };

  const redirectTo = (path) => {
    history.push(`/app/${path}`);
  };

  const sendWeeklyNewsletter = async () => {
    setLoading(true);
    const res = await post("/send_weekly_newsletter");
    if (res.status) {
      setLoading(false);
    }
  };

  const createShortLinks = async () => {
    const mr = await get("medicalRequests");
    console.log("mr", mr);
    mr.map(async (item, i) => {
      setLoading(true);
      if (item.certLink) {
        await add("shortLinks", {
          link: item.certLink,
          code: `cert_${item.id}`,
          date: item.dob,
        });
      }
      if (item.prescriptionLink) {
        await add("shortLinks", {
          link: item.prescriptionLink,
          code: `pres_${item.id}`,
          date: item.dob,
        });
      }
      setLoading(false);
    });
  };

  return (
    <div className="section">
      <div className="section-header">
        Admin zone {loading && <i className="fa fa-spin fa-spinner"></i>}
      </div>
      <ul className="section-list">
        <li>
          <div className="d-flex flex-row align-items-center justify-content-between pointer">
            <span
              className="option-name"
              htmlFor="customSwitch1"
              onClick={(e) => redirectTo("withdraw_requests")}
            >
              Withdraw Requests
            </span>
          </div>
        </li>
        <li>
          <div className="d-flex flex-row align-items-center justify-content-between pointer">
            <span
              className="option-name"
              htmlFor="customSwitch1"
              onClick={(e) => redirectTo("send_company_alerts")}
            >
              Send company alerts
            </span>
          </div>
        </li>
        <li>
          <div className="d-flex flex-row align-items-center justify-content-between pointer">
            <span
              className="option-name"
              htmlFor="customSwitch1"
              onClick={updateCategories}
            >
              Update categories
            </span>
          </div>
        </li>
        <li>
          <div className="d-flex flex-row align-items-center justify-content-between pointer">
            <span
              className="option-name"
              htmlFor="customSwitch1"
              onClick={mergePosts}
            >
              Merge feelings and activities
            </span>
          </div>
        </li>
        <li>
          <div className="d-flex flex-row align-items-center justify-content-between pointer">
            <span
              className="option-name"
              htmlFor="customSwitch1"
              onClick={updateRelationshipStatus}
            >
              Update relationship statuses
            </span>
          </div>
        </li>
        <li>
          <div className="d-flex flex-row align-items-center justify-content-between pointer">
            <span
              className="option-name"
              htmlFor="customSwitch1"
              onClick={sendWeeklyNewsletter}
            >
              Send weekly newsletter
            </span>
          </div>
        </li>
        <li>
          <div className="d-flex flex-row align-items-center justify-content-between pointer">
            <span
              className="option-name"
              htmlFor="customSwitch1"
              onClick={createShortLinks}
            >
              Create Short Links
            </span>
          </div>
        </li>
      </ul>
    </div>
  );
}

export default AdminZoneComponent;
